import { DriverItem } from "app/data/drivers/models";

export interface DriverState {
    selectedDriverId: string | null;
    selectedDriver: DriverItem | null;
}
  
export const initialState: DriverState = {
    selectedDriverId: null,
    selectedDriver: null,
};
  